export var FIELD_META_PROP = 'data-__meta';
export var FIELD_DATA_PROP = 'data-__field';


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/form/constants.js
// module id = 313
// module chunks = 0